<div class="dl-ballon"
     [class.dl-ballon--toon]="modus === 'toon'"
     [class.dl-ballon--bewerk]="modus === 'bewerk'"
     [class.dl-ballon--boven]="hoek().verticaal === 'boven'"
     [class.dl-ballon--onder]="hoek().verticaal === 'onder'"
     [class.dl-ballon--links]="hoek().horizontaal === 'links'"
     [class.dl-ballon--rechts]="hoek().horizontaal === 'rechts'"
     [dlNodeVolger]="node"
     [cy]="cy"
     ankertype="midden"
     [volgFormaat]="false"
     [offset]="ankeroffset">
    <div class="dl-ballon__vak">
        <div class="dl-ballon__tekst">
            @if (!readonly) {
                <div class="dl-ballon__sluit"
                     [class.dl-ballon__sluit--scherp]="sluitstap()"
                     [title]="'BALLON.KLIK2XOMTESLUITEN' | translate"
                     (click)="klikSluit()">X</div>
            }
            @if (modus === 'bewerk') {
                <div class="dl-ballon__formulier">
                    <textarea #invoerveld
                              class="form-control form-control-sm"
                              aria-label="Tekst"
                              [value]="invoer()"
                              (input)="zetInvoer($event)"></textarea>
                    <div class="text-end mt-2">
                        <button type="button" class="btn btn-sm btn-light dl-ballon__opslaan"
                                (click)="bewaar()">{{ 'BTN_SAVE' | translate }}</button>
                    </div>
                </div>
            } @else {
                <div class="dl-ballon__inhoud">
                    <div>{{ tekst }}</div>
                    <div><em>{{ auteur }}</em></div>
                </div>
            }
        </div>
    </div>
</div>
